import { PatientFamilyHistoryControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchivePatientFamilyHistory = () =>
  useMutationWithLoading(
    async (param: {
      patientFamilyHistoryId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientFamilyHistoryControllerApi(
        getConfigObject()
      ).deletePatientFamilyHistoryId(
        param.patientFamilyHistoryId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
